import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, Observable, Subject } from 'rxjs';
import { environment } from 'src/environemnts/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  sessionToken: string = "";
  userSessionInfo: any;
  userProfileData: any = {};
  pilot: any;
  uuid: number;
  role: string;
  logId: number = 0;
  loginTime: number = 0;

  //Observables
  private authConfirmed = new Subject<any>();
  authConfirmed$ = this.authConfirmed.asObservable();
  private profileData = new Subject<any>();
  profileData$ = this.profileData.asObservable();
  private profileIdsFromClassData = new Subject<any>();
  profileIdsFromClassData$ = this.profileIdsFromClassData.asObservable();
  private refreshedToken = new Subject<any>();
  refreshedToken$ = this.refreshedToken.asObservable();
  private logsSaved = new Subject<any>();
  logsSaved$ = this.logsSaved.asObservable();
  private childrenRegistrationStatus = new Subject<any>();
  childrenRegistrationStatus$ = this.childrenRegistrationStatus.asObservable();

  constructor(private httpClient: HttpClient) { }


  /**
   * Method to login
   * @param email 
   * @param password 
   */
  login(email: string, password: string) {

    let headers = {
      headers: new HttpHeaders()
    }

    let body = {
      "email": email,
      "password": password
    }


    this.httpClient.post('https://sunrise.pasiphae.eu/sunrise/asapa/login', body, headers).subscribe((data: any) => {

      if (data.items.claims.role == 'CHILD_ROLE' || data.items.claims.role == 'PARENT_ROLE') {
        this.authConfirmed.next("errorRole");
      } else {
        let dataFormatted = JSON.parse(JSON.stringify(data));
        this.sessionToken = dataFormatted.items.token;
        this.userSessionInfo = dataFormatted.items.claims;
        this.uuid = dataFormatted.items.claims.user_uuid;

        this.pilot = dataFormatted.items.claims.pilot;
        this.role = dataFormatted.items.claims.role;

        this.loginTime = new Date().getTime()

        this.authConfirmed.next(this.sessionToken)
      }

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.authConfirmed.next(`error${error.error.code},${error.error.more}`);
      throw new Error(`Error in login() method with user email: ${email}, error ${error.error.code}, description ${JSON.stringify(error.error.more)}`);

    })

  }

  /**
   * Method to refresh the token
   */
  refreshToken() {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.sessionToken)
    }


    return this.httpClient.post(environment.ASAPAbaseUrl + '/auth/token/refresh', {}, headers);

  }


  /**
   * Get profile data
   * @param id profile id
   */
  getUserProfile(id: string) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.sessionToken)
        .set('X-Pilot-Code', this.pilot)
        .set('X-User-Role', this.role)
        .set('X-User-Id', String(this.uuid))
    }

    sessionStorage.setItem('X-Pasiphae-Auth', this.sessionToken)
    sessionStorage.setItem('X-Pilot-Code', this.pilot)
    sessionStorage.setItem('X-User-Role', this.role)
    sessionStorage.setItem('X-User-Id', String(this.uuid))

    this.httpClient.get(environment.baseUrl + '/Profiles/' + id, headers).subscribe((data: any) => {

      if(!Array.isArray(data) || data.length==0){
        this.profileData.next(`errorProfile`);
        throw new Error(`errorProfile`)
      }else{
        let datos = JSON.parse(JSON.stringify(data));
        if(datos[0].id==sessionStorage.getItem("X-User-Id")) {
          this.userProfileData = JSON.parse(JSON.stringify(data))[0];
          this.profileData.next(datos);
        }
      }

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.profileData.next(`error${error.status},${error.message}`);
      throw new Error(`Error in getUserProfile() method with user id: ${this.uuid}, pilot: ${this.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })

  }


  /**
 * Method to create a user profile
 */
  createProfile(profile: any) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.sessionToken)
        .set('X-Pilot-Code', this.pilot)
        .set('X-User-Role', this.role)
        .set('X-User-Id', String(this.uuid))
    }

    let body = profile;

    return this.httpClient.post(environment.baseUrl + '/Profiles', body, headers);

  }

  /**
   * Method to remove a user profile
   * @param profileId 
   * @returns 
   */
  removeProfile(profileId: number) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.sessionToken)
        .set('X-Pilot-Code', this.pilot)
        .set('X-User-Role', this.role)
        .set('X-User-Id', String(this.uuid))
    }

    return this.httpClient.delete(environment.baseUrl + '/Profiles/' + profileId, headers);


  }


  /**
   * Method to get all the profile ids from a class
   */
  getUnregisteredProfileIdsFromAClass(classIds: Array<any>) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.sessionToken)
        .set('X-Pilot-Code', this.pilot)
        .set('X-User-Role', this.role)
        .set('X-User-Id', String(this.uuid))
    }

    let body = classIds;

    this.httpClient.post(environment.baseUrl + '/ClassProfiles/findUnregisteredProfilesByClassList', body, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));

      this.profileIdsFromClassData.next(datos);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.profileIdsFromClassData.next('error' + error.status + error.error);
      throw new Error(`Error in getUnregisteredProfileIdsFromAClass() method with user id: ${this.uuid}, pilot: ${this.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })

  }


  /**
* Method to get the registered users in ASAPA
* @returns 
*/
  getRegisteredUsers() {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.sessionToken)
    }

    let body = {
      "projection": [
        "user_uuid",
        "pilot",
        "active",
        "consent_signed"

      ],
      "filter": {
        "pilot": String(this.pilot),
      }
    }


    return this.httpClient.post(environment.ASAPAbaseUrl + '/users/', body, headers);

  }


/**
* Method to get if the user is registered in ASAPA
* @returns boolean
*/
  getIfUserIsRegistered(uuid: string) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.sessionToken)
    }

    let body = {
      "filter": {
        "user_uuid": String(uuid),
        "pilot": String(this.pilot),
      }
    }

    return this.httpClient.post(environment.ASAPAbaseUrl + '/users/', body, headers);

  }

  /**
  * Method to get the registered users in ASAPA
  * @returns 
  */
  getUsersRegistrationStatuss() {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.sessionToken)
    }

    let body = {
     "projection": [
        "user_uuid",
        "pilot",
        "active",
        "created_at",
        "email",
        "consent_signed",
        "roles"
      ],
      "filter": {
        "pilot": String(this.pilot),
      }
    }


    this.httpClient.post(environment.ASAPAbaseUrl + '/users/', body, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));
      this.childrenRegistrationStatus.next(datos.items);


    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.authConfirmed.next(`error${error.error.code},${error.error.more}`);
      throw new Error(`Error in getUsersRegistrationStatuss() method with user uuid: ${this.uuid}, pilot: ${this.pilot}, error ${error.error.code}, description ${JSON.stringify(error.error.more)}`);

    })

  }


  /**
   * Method to updated the registration status from 0 (not registered) to 1 (registered)
   * @param profilesIds 
   */
  updateUsersRegistrationStatus(profilesIds: number[]) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.sessionToken)
        .set('X-Pilot-Code', this.pilot)
        .set('X-User-Role', this.role)
        .set('X-User-Id', String(this.uuid))
    }

    let body = profilesIds;

    return this.httpClient.post(environment.baseUrl + '/Profiles/changeToRegistered', body, headers)

  }


  /**
   * Method to save the logs
   */
  saveLogs() {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.sessionToken)
        .set('X-Pilot-Code', this.pilot)
        .set('X-User-Role', this.role)
        .set('X-User-Id', String(this.uuid))
    }

    let body = {
      "profileId": this.userProfileData.id,
      "tool": 9, //Authoring tool
      "sessionDurationInSeconds": 0
    };

    return this.httpClient.post(environment.baseUrl + '/UserLoggingLogs', body, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));

      this.logId = datos[0].id;
      sessionStorage.setItem('logId', String(this.logId));
      sessionStorage.setItem('loginTime', String(this.loginTime));

      this.logsSaved.next(datos);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.logsSaved.next('error' + error.status + error.error);
      throw new Error(`Error in saveLogs() method with user id: ${this.uuid}, pilot: ${this.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })

  }

  /**
   * Method to update session duration in logs
   * @param sessionDuration 
   */
  updateLogsSessionDuration(sessionDuration: number, logId: Number) {

    let headers = {
      headers: new HttpHeaders()
    }

    if (this.sessionToken != "") {
      headers = {
        headers: new HttpHeaders()
          .set('X-Pasiphae-Auth', this.sessionToken)
          .set('X-Pilot-Code', this.pilot)
          .set('X-User-Role', this.role)
          .set('X-User-Id', String(this.uuid))
      }

    } else if (sessionStorage.getItem("X-Pasiphae-Auth") != null && sessionStorage.getItem("X-Pilot-Code") != null && sessionStorage.getItem("X-User-Role") != null && sessionStorage.getItem("X-User-Id") != null) {
      headers = {
        headers: new HttpHeaders()
          .set('X-Pasiphae-Auth', sessionStorage.getItem("X-Pasiphae-Auth")!)
          .set('X-Pilot-Code', sessionStorage.getItem("X-Pilot-Code")!)
          .set('X-User-Role', sessionStorage.getItem("X-User-Role")!)
          .set('X-User-Id', sessionStorage.getItem("X-User-Id")!)
      }

    }

    let body = {
      "sessionDurationInSeconds": sessionDuration
    };

    return this.httpClient.patch(environment.baseUrl + '/UserLoggingLogs/' + logId, body, headers);

  }

  /**
   * Method to recover the password
   * @param email 
   * @returns 
   */
  recoverPassword(email: string) {

        let headers = {
      headers: new HttpHeaders()
        // .set('X-Pasiphae-Auth', this.sessionToken)
        // .set('X-Pilot-Code', this.pilot)
        // .set('X-User-Role', this.role)
        // .set('X-User-Id', String(this.uuid))
    }

    let body = {
      'email': email
    };

    return this.httpClient.post(environment.ASAPAbaseUrl + '/auth/password/recovery', body, headers)

  }


  /**
   * Method to clean variables
   */
  cleanVariables() {

    this.sessionToken = "";
    this.userSessionInfo = {};
    this.userProfileData = {};
    this.pilot = "";
    this.uuid = 0;
    this.role = "";
    this.logId = 0;
    this.loginTime = 0;
    sessionStorage.removeItem('logId');
    sessionStorage.removeItem('loginTime');
    sessionStorage.removeItem('X-Pasiphae-Auth');
    sessionStorage.removeItem('X-Pilot-Code');
    sessionStorage.removeItem('X-User-Role');
    sessionStorage.removeItem('X-User-Id');
  }


  /**
   * Method to clean credentials variables when logout
   */
  logoutClean() {
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('pwd');
  }


  /**
 * Method to read JSON file
 * @param location 
 * @returns 
 */
  getJSON(location: string): Observable<any> {
    return this.httpClient.get(location);
  }




}
